module.exports = __webpack_public_path__ + "img/primary-view.bb651ca7.svg";